import React, { useEffect } from "react";
import CareersHero from "./CareersHeroSection/CareersHero";
import StudentsCareers from "./StudentsCareers/StudentsCareers";
import Professionals from "./professional/Professionals";
import Location from "./Location/Location";
import StepsToYourNextJob from "./join/StepsToYourNextJob";
import Nav from "./Nav/Nav";
const Careers = () => {
  useEffect(() => {
    document.title = "Codequeue - Careers";
    window.scrollTo({ top: "0", behavior: "smooth" });
  }, []);
  return (
    <div>
      <CareersHero />
      <Nav />
      <div id="students-careers">
        <StudentsCareers />
      </div>
      <div id="professionals">
        <Professionals />
      </div>
      <div id="locations">
        <Location />
      </div>
      <div id="join-us">
        <StepsToYourNextJob />
      </div>
    </div>
  );
};

export default Careers;
